import { useAppSelector } from '@/store/hooks';
import { selectPermissions, selectAuthLoaded, selectUser } from '@/store/slices/authSlice';

interface UsePermissionsReturn {
  hasPermission: (permission: string | string[]) => boolean;
  isLoading: boolean;
  permissions: string[];
}

export const usePermissions = (): UsePermissionsReturn => {
  const permissions = useAppSelector(selectPermissions);
  const authLoaded = useAppSelector(selectAuthLoaded);
  const user = useAppSelector(selectUser);
  const isLoading = !authLoaded || (authLoaded && !user);

  const hasPermission = (permission: string | string[]): boolean => {
    if (permissions.includes('admin')) return true;
    
    if (Array.isArray(permission)) {
      // If any permission in the array is valid, return true
      return permission.some(p => 
        p === 'user' && permissions.includes('editor') || permissions.includes(p)
      );
    }
    
    if (permission === 'user' && permissions.includes('editor')) return true;
    
    return permissions.includes(permission);
  };

  return { hasPermission, isLoading, permissions };
}; 